///
/// EarthBrowser
///
/// Created by Matt Giger on 4/21/2024
/// Copyright (c) 2024 Geodata Labs
///

import { NodeBase } from "@stovokor/engine/NodeBase"
import { type RenderActionSet } from "@stovokor/engine/Renderer"
import { type RenderState } from "@stovokor/engine/RenderState"
import { type GLTFGeometry } from "@/earthbrowser/entities/GLTF/GLTFGeometry"
import { type GLTFRenderer } from "@/earthbrowser/entities/GLTF/GLTFRenderer"
import { matrix } from "@stovokor/math/matrix"

export class GLTFMeshPrimitive extends NodeBase {

	public normalizeUnits = false
	public scale = 80

	constructor(geometry: GLTFGeometry, renderer: GLTFRenderer) {
		super()
		this.renderer = renderer

		if(this.normalizeUnits) {
			const bounds = geometry.bounds
			const scale = this.scale * 2 / Math.max(bounds.max.x - bounds.min.x, bounds.max.y - bounds.min.y, bounds.max.z - bounds.min.z)
			this.transform = matrix.scale(scale, scale, scale).multiply(this.transform)
		}
	}

	override render(state: RenderState): RenderActionSet[] {
		return super.render(state)
	}
}
